module.exports = new __parcel__URL__("Collab.495795d1.png").toString();